import { Route, Routes } from "react-router-dom";
import Klass from "../page/mordern_class/Klass";
import KlassSearch from "../page/mordern_class/KlassSearch";
import KlassLecture from "../page/mordern_class/KlassLecture";
import ChannelTalk from "component/ChannelTalk";
import KlassCuration from "../page/mordern_class/KlassCuration";

const KlassRoute: React.FC = () => {
  return (
    <article>
      <Routes>
        <Route path="/curation/:curationId" element={<KlassCuration />} />
        <Route path="/search" element={<KlassSearch />} />
        <Route path="/course/:id" element={<KlassLecture />} />
        <Route path="/*" element={<Klass />} />
      </Routes>
      <ChannelTalk />
    </article>
  );
};

export default KlassRoute;
